// Pasos: identidad, presentador, plan del mes y medición.
export default {
  // Identidad
  'Tu identidad': 'Your identity',
  'Muéstranos tu logo y diseños que te gusten; tus publicaciones se verán de tu marca, y mejor.':
    "Show us your logo and designs you like; your posts will look like your brand, only better.",
  'Subiendo tu logo…': 'Uploading your logo…',
  'Subiendo tus referencias…': 'Uploading your references…',
  'Subiendo tu manual…': 'Uploading your brand guide…',
  'Tu manual de identidad': 'Your brand guide',
  opcional: 'optional',
  'El manual debe ser un PDF': 'The brand guide must be a PDF',
  'El manual no puede pesar más de 20 MB': "The brand guide can't be larger than 20 MB",
  'Si tu marca tiene manual, súbelo: de ahí saco tus colores, tus letras y cómo se usa tu logo.':
    "If your brand has a guide, upload it: I'll take your colors, your fonts and how your logo is used from there.",
  'Tu logo': 'Your logo',
  'hasta 6 versiones': 'up to 6 versions',
  'Sube las versiones que tengas. Uso la que corresponda según el fondo de cada diseño.':
    'Upload all the versions you have. I use the right one for the background of each design.',
  'Diseños que te gustan': 'Designs you like',
  'de 1 a 10 imágenes': '1 to 10 images',
  '¿Algo que debamos saber de tu estilo?': 'Anything we should know about your style?',
  'Nada de fotos de stock, por favor': 'No stock photos, please',
  'Definir mi estilo': 'Define my style',
  'Cada archivo, máximo 5 MB (el manual, 20 MB).': 'Each file up to 5 MB (the brand guide, 20 MB).',
  '¡Guardados!': 'Saved!',
  'Todavía no tenemos tu estilo definido.': "We haven't defined your style yet.",
  'Guardado. Tus próximos diseños ya usan estos cambios. Si quieres que IGOR vuelva a leer tu estilo con ellos (el resumen, las letras, las fotos), usa "Cambiar algo" y pídeselo.':
    'Saved. Your next designs already use these changes. If you want IGOR to re-read your style with them (the summary, the fonts, the photos), use "Change something" and ask for it.',
  'Tu estilo': 'Your style',
  'Con manual': 'With brand guide',
  'Su ánimo': 'Its mood',
  'De aquí salieron tus colores y tus letras': 'Your colors and fonts came from here',
  Ver: 'View',
  Quitar: 'Remove',
  'Quitar esta versión': 'Remove this version',
  'Ver versión {n}': 'View version {n}',
  'Agregar versión del logo': 'Add a logo version',
  'Esta versión sirve para': 'This version works for',
  'Para fondo claro': 'Light backgrounds',
  'Para fondo oscuro': 'Dark backgrounds',
  Horizontal: 'Horizontal',
  Vertical: 'Vertical',
  'Sube tu logo (y sus versiones)': 'Upload your logo (and its versions)',
  'Tus colores': 'Your colors',
  'Agregar color': 'Add color',
  'Guardando…': 'Saving…',
  'Guardar colores': 'Save colors',
  'Cambiar {color}': 'Change {color}',
  color: 'color',
  'Para qué se usa': "What it's used for",
  'Quitar este color': 'Remove this color',
  Nombre: 'Name',
  Fondo: 'Background',
  Superficie: 'Surface',
  Primario: 'Primary',
  Acento: 'Accent',
  Texto: 'Text',
  'Toca un color para cambiarlo, elige para qué se usa y ponle nombre. Lo que pongas aquí manda sobre lo que dedujimos. Guardar no usa créditos.':
    "Tap a color to change it, choose what it's used for and give it a name. What you set here wins over what we figured out. Saving doesn't use credits.",
  'Tus letras': 'Your fonts',
  'Sin definir': 'Not set',
  'en mayúsculas': 'in capitals',
  'Serif elegante': 'Elegant serif',
  'Moderna geométrica': 'Modern geometric',
  'Moderna amable': 'Modern and friendly',
  'Gruesa de impacto': 'Bold and punchy',
  'Alta y condensada': 'Tall and condensed',
  'Con carácter': 'With character',
  'Editorial · elegante y con aire de revista': 'Editorial · elegant, with a magazine feel',
  'Bold · impacto, letras grandes y color fuerte': 'Bold · impact, big letters and strong color',
  'Suave · cercano, redondeado y cálido': 'Soft · friendly, rounded and warm',
  'Minimalista · limpio, ordenado y con mucho blanco': 'Minimalist · clean, tidy and lots of white space',
  Grosor: 'Weight',
  Ligera: 'Light',
  Normal: 'Regular',
  Negrita: 'Bold',
  Extra: 'Extra bold',
  'Cómo se ordenan tus piezas': 'How your posts are laid out',
  'Cuánto cabe en una pieza': 'How much fits in a post',
  Aireada: 'Airy',
  Equilibrada: 'Balanced',
  Llena: 'Packed',
  Fotos: 'Photos',
  Nunca: 'Never',
  'A veces': 'Sometimes',
  Siempre: 'Always',
  Alineación: 'Alignment',
  'Al centro': 'Centered',
  'A la izquierda': 'Left',
  'Tus fotos': 'Your photos',
  Estilo: 'Style',
  Luz: 'Light',
  Color: 'Color',
  'Qué aparece': "What's in them",
  'Lo que te gusta': 'What you like',
  Referencia: 'Reference',
  'Quitar esta referencia': 'Remove this reference',
  'Agregar referencias': 'Add references',
  Agregar: 'Add',
  'Elementos que se repiten': 'Recurring elements',
  Conservamos: 'We keep',
  Mejoramos: 'We improve',
  Evitamos: 'We avoid',

  // Presentador
  'Tus presentadores': 'Your presenters',
  'Las personas que salen hablando en tus reels. Puedes guardar hasta tres y repartirlas entre tus videos.':
    'The people who speak in your reels. You can keep up to three and spread them across your videos.',
  'Te propongo tres personas que encajan con tu cliente. Puedes quedarte con una, con dos o con las tres.':
    "I'll suggest three people who fit your customer. You can keep one, two or all three.",
  '¿Cómo te las imaginas?': 'How do you picture them?',
  'Un hombre joven, con ropa de trabajo': 'A young man in work clothes',
  'Proponerme presentadores': 'Suggest presenters',
  'Tarda alrededor de un minuto · {n} créditos.': 'Takes about a minute · {n} credits.',
  Cara: 'Face',
  Voz: 'Voice',
  Fijada: 'Locked',
  'Sin fijar': 'Not locked',
  'De tu país': 'From your country',
  '¿Borrar a {nombre}? Deja de estar en tus opciones y en tu equipo. No se puede deshacer.':
    "Delete {nombre}? They'll be removed from your options and your team. This can't be undone.",
  'No hay personas propuestas todavía.': 'No suggested people yet.',
  'Sala de presentadores': 'Presenter room',
  Equipo: 'Team',
  'Caras fijadas': 'Locked faces',
  Perfil: 'Profile',
  Edad: 'Age',
  Estado: 'Status',
  'En tu equipo': 'On your team',
  Disponible: 'Available',
  'Quitar del equipo': 'Remove from team',
  'Sumar a mi equipo': 'Add to my team',
  'Fijar su cara · {n} crédito': 'Lock their face · {n} credit',
  'Hacer un video': 'Make a video',
  'Tu equipo está completo: quita a alguien para sumarla.': 'Your team is full: remove someone to add this person.',
  'Borrar a {nombre}': 'Delete {nombre}',
  'IDENTIDAD FIJADA': 'IDENTITY LOCKED',
  'EN EL EQUIPO': 'ON THE TEAM',
  CANDIDATA: 'CANDIDATE',
  'Nueve ángulos': 'Nine angles',
  'Nueve ángulos de {nombre}': 'Nine angles of {nombre}',
  'Fija su cara para crearlos': 'Lock their face to create them',
  'Súmala a tu equipo primero': 'Add them to your team first',
  'Van con cada video suyo para que siempre sea la misma persona.':
    'They go with each of their videos so it is always the same person.',
  'Por qué estas personas': 'Why these people',
  'Ver a {nombre}': 'View {nombre}',
  'Crear una persona nueva': 'Create a new person',
  Nueva: 'New',
  'La foto pesa más de 5 MB.': 'The photo is larger than 5 MB.',
  'Nueva persona': 'New person',
  Cerrar: 'Close',
  'Descríbela': 'Describe them',
  'Con una foto': 'With a photo',
  '¿Cómo es? Su edad, su pelo, su estilo, su ropa, dónde está.':
    'What are they like? Their age, hair, style, clothes, where they are.',
  'Mujer de unos 35 años, pelo castaño corto, sonrisa amable, camisa blanca, en una cocina luminosa':
    'Woman around 35, short brown hair, kind smile, white shirt, in a bright kitchen',
  'La foto que vas a subir': "The photo you're uploading",
  'Sube una foto de frente, con buena luz': 'Upload a front-facing photo with good light',
  'Confirmo que tengo la autorización de la persona de esta foto para usar su imagen y crear con ella videos con inteligencia artificial para mi marca.':
    'I confirm I have permission from the person in this photo to use their image and create AI videos with it for my brand.',
  'Su nombre': 'Their name',
  'Si no, se lo ponemos nosotros': "If not, we'll pick one",
  'Empezando…': 'Starting…',
  'Crear presentador · {n} crédito': 'Create presenter · {n} credit',
  'Usamos la foto tal cual; la IA solo la lee para que los videos la respeten.':
    'We use the photo as is; the AI only reads it so the videos stay true to it.',
  'La IA la crea con tu descripción y le hace su foto. Tarda alrededor de un minuto.':
    'The AI creates them from your description and takes their photo. Takes about a minute.',

  // Plan del mes
  'Plan del mes': 'Monthly plan',
  'Tu calendario: qué publicar, cuándo y en qué formato.': 'Your calendar: what to post, when and in which format.',
  '¿Qué mes planeamos?': 'Which month are we planning?',
  '¿Cuántas publicaciones?': 'How many posts?',
  '¿En qué redes?': 'On which networks?',
  'Armar mi plan': 'Build my plan',
  'Los reels cuestan más créditos que las estáticas y los carruseles.': 'Reels cost more credits than single images and carousels.',
  Publicaciones: 'Posts',
  'En el mes': 'This month',
  Reel: 'Reel',
  Reels: 'Reels',
  Carrusel: 'Carousel',
  Carruseles: 'Carousels',
  Estática: 'Image',
  Imágenes: 'Images',
  'Semana anterior': 'Previous week',
  'Semana siguiente': 'Next week',
  Semana: 'Week',
  Mes: 'Month',
  Lista: 'List',
  Lun: 'Mon',
  Mar: 'Tue',
  Mié: 'Wed',
  Jue: 'Thu',
  Vie: 'Fri',
  Sáb: 'Sat',
  Dom: 'Sun',
  'Toca una publicación para ver su detalle.': 'Tap a post to see its details.',
  'Fecha especial': 'Special date',
  'Qué pides': "What you're asking for",
  'Para qué sirve': "What it's for",
  'Dónde': 'Where',
  'Por qué este día': 'Why this day',
  Enseña: 'Teaches',
  Acerca: 'Connects',
  'Da confianza': 'Builds trust',
  Vende: 'Sells',
  'Llegar a más gente': 'Reach more people',
  'Conversación': 'Conversation',
  Ventas: 'Sales',
  Comunidad: 'Community',
  Confianza: 'Trust',
  // Fechas comerciales (packages/core/src/calendar/commercial-dates.ts)
  'Día de San Valentín': "Valentine's Day",
  'Día de la Mujer': "International Women's Day",
  Halloween: 'Halloween',
  'Black Friday': 'Black Friday',
  Nochebuena: 'Christmas Eve',
  Navidad: 'Christmas',
  'Fin de año': "New Year's Eve",
  'Día de la Madre': "Mother's Day",
  'Día del Padre': "Father's Day",
  'Amor y Amistad': 'Love and Friendship Day',
  'Noche de Velitas': 'Night of the Little Candles',
  'Inicio de la Novena de Aguinaldos': 'Start of the Christmas Novena',
  'Día de Muertos': 'Day of the Dead',
  'Día de la Virgen de Guadalupe': 'Our Lady of Guadalupe Day',
  'Fiestas Patrias': 'National Holidays',

  // Medición
  'Semana {n}': 'Week {n}',
  Medición: 'Results',
  'Cómo le fue a tu mes: el alcance de tus cuentas y el resultado de cada pieza publicada.':
    'How your month went: the reach of your accounts and the results of each published post.',
  'Medido {fecha}': 'Measured {fecha}',
  'Midiendo…': 'Measuring…',
  'Actualizar ahora': 'Update now',
  'Cargando…': 'Loading…',
  Alcance: 'Reach',
  'Personas que te vieron': 'People who saw you',
  Impresiones: 'Impressions',
  'Veces que se vio': 'Times it was seen',
  Interacciones: 'Interactions',
  'Me gusta, comentarios y compartidos': 'Likes, comments and shares',
  'Seguidores nuevos': 'New followers',
  'Este mes': 'This month',
  'Salieron este mes': 'Went out this month',
  'Cómo te vieron cada semana': 'How people saw you each week',
  'Aquí verás la evolución semana a semana cuando tus cuentas estén conectadas.':
    "You'll see your week-by-week progress here once your accounts are connected.",
  'Por red': 'By network',
  Red: 'Network',
  'Conecta tus cuentas en Publicar para comparar tus redes.': 'Connect your accounts in Publish to compare your networks.',
  'Tus piezas publicadas': 'Your published posts',
  '{n} medidas': '{n} measured',
  '{n} por medir': '{n} to measure',
  'Pieza {n}': 'Post {n}',
  interacciones: 'interactions',
  vistas: 'views',
  Pieza: 'Post',
  'Me gusta': 'Likes',
  Comentarios: 'Comments',
  Compartidos: 'Shares',
  Vistas: 'Views',
  'Ver ›': 'View ›',
  'Tus piezas ya salieron: pulsa "Actualizar ahora" y en unos minutos verás cómo les fue.':
    'Your posts are out: tap "Update now" and in a few minutes you\'ll see how they did.',
  'Cuando tus piezas se publiquen, aquí verás cuántos me gusta, comentarios y vistas tuvo cada una. Se mide sola cada día.':
    "Once your posts go live, you'll see how many likes, comments and views each one got here. It's measured automatically every day.",
  'Antes y ahora': 'Before and now',
  'Antes de IGOR': 'Before IGOR',
  'Interacciones promedio por publicación': 'Average interactions per post',
  'Qué formato funcionó': 'Which format worked',
  'Qué tema funcionó': 'Which topic worked',
  'El alcance y las impresiones salen de tus cuentas conectadas. Por publicación vemos los datos públicos (me gusta, comentarios, compartidos y vistas); el alcance y los guardados de cada una los da solo la red.':
    'Reach and impressions come from your connected accounts. For each post we see the public data (likes, comments, shares and views); only the network itself provides each post\'s reach and saves.',
  "{n} publicaciones en {mes}: {reels} reels, {carruseles} carruseles y {imagenes} imágenes.": "{n} posts in {mes}: {reels} reels, {carruseles} carousels and {imagenes} images.",
  "Ver en calendario": "See in calendar",
  "Semana del {dia}": "Week of {dia}",
  "‹ Ver por semanas": "‹ See by week",
} satisfies Record<string, string>;
